import styled, {css} from 'styled-components';

import {excludeStyledProps} from '../../../data-ui/style-util';

/**
 * @type {import("styled-components").StyledComponent<"div", any, {space: string}, {fullWidth: boolean}, never> & {Align: typeof SpacerAlign, Stacked: typeof SpacerStacked}}
 */
export const Spacer = styled.div`
    display: flex;
    ${({space}) => {
        if (space) {
            return css`
                gap: var(--space-${space}) !important;
            `;
        } else {
            return null;
        }
    }}
    ${({fullWidth}) => {
        if (fullWidth) {
            return css`
                width: 100%;
            `;
        }
    }}
`;

/**
 * @type {import("styled-components").StyledComponent<"div", any, {
 * align?: "normal" | "stretch" | "center" | "start" | "end" | "flex-start" | "flex-end" | "self-start" | "self-end" | "anchor-center" | "baseline" | "first baseline" | "last baseline" | "safe center" | "unsafe center" | "inherit" | "initial" | "revert" | "revert-layer" | "unset";
 * space?: string;
 * }, never>}
 */
const SpacerStacked = styled(Spacer).withConfig(excludeStyledProps('align'))`
    flex-direction: column;
    ${({align}) =>
        align &&
        css`
            align-items: ${align};
        `}
`;

/**
 * @type {import("styled-components").StyledComponent<"div", any, {
 * align?: "normal" | "stretch" | "center" | "start" | "end" | "flex-start" | "flex-end" | "self-start" | "self-end" | "anchor-center" | "baseline" | "first baseline" | "last baseline" | "safe center" | "unsafe center" | "inherit" | "initial" | "revert" | "revert-layer" | "unset";
 * justify?: "normal" | "stretch" | "center" | "start" | "end" | "flex-start" | "flex-end" | "self-start" | "self-end" | "anchor-center" | "baseline" | "first baseline" | "last baseline" | "safe center" | "unsafe center" | "inherit" | "initial" | "revert" | "revert-layer" | "unset";
 * spaceBetween?: boolean;
 * space?: string;
 * wrap?: boolean;
 * }, never>}
 */
const SpacerAlign = styled(Spacer).withConfig(excludeStyledProps('align', 'spaceBetween', 'wrap'))`
    flex-direction: row;
    ${({spaceBetween}) => {
        if (spaceBetween) {
            return css`
                justify-content: space-between;
            `;
        }
    }}
    ${({align, spaceBetween}) =>
        (align || spaceBetween) &&
        css`
            align-items: ${align ?? 'center'};
        `}

    ${({justify}) =>
        justify &&
        css`
            justify-content: ${justify};
        `}

    ${({wrap}) => {
        if (wrap) {
            return css`
                flex-wrap: wrap;
            `;
        }
    }}
`;

Spacer.Stacked = SpacerStacked;
Spacer.Align = SpacerAlign;
export {SpacerStacked};
